import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { activeProjects, createTimeEntry, deleteEntry, flagUpdate, getAdminEntries, getAllTeamEntries, getEntry, getTimeEntry, supervisorTeam, updateTimeEntry } from "../api";
import { Constant } from "src/lib/Constants";
import {
  ACTIVE_PROJECT_ERROR,
  ACTIVE_PROJECT_LOADING,
  ACTIVE_PROJECT_SUCCESS,
  ADD_TIME_ENTRY_ERROR,
  ADD_TIME_ENTRY_LOADING,
  ADD_TIME_ENTRY_SUCCESS,
  DELETE_ENTRY_ERROR,
  DELETE_ENTRY_SUCCESS,
  GET_ALL_ENTRIES_ERROR,
  GET_ALL_ENTRIES_LOADING,
  GET_ALL_ENTRIES_SUCCESS,
  GET_ENTRY_ERROR,
  GET_ENTRY_LOADING,
  GET_ENTRY_SUCCESS,
  GET_TIME_ENTRY_ERROR,
  GET_TIME_ENTRY_LOADING,
  GET_TIME_ENTRY_SUCCESS,
  SUPERVISOR_ALL_ENTRIES_ERROR,
  SUPERVISOR_ALL_ENTRIES_LOADING,
  SUPERVISOR_ALL_ENTRIES_SUCCESS,
  SUPERVISOR_TEAM_ERROR,
  SUPERVISOR_TEAM_SUCCESS,
  UPDATE_ENTRY_ERROR,
  UPDATE_ENTRY_LOADING,
  UPDATE_ENTRY_SUCCESS,
  UPDATE_FLAG_ERROR,
  UPDATE_FLAG_SUCCESS,
} from "src/redux/types";

function* activeProjectsFetch() {
  yield put({
    type: ACTIVE_PROJECT_LOADING,
    payload: true,
  });
  try {
    let res = yield call(activeProjects);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: ACTIVE_PROJECT_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: ACTIVE_PROJECT_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* entryGet(action) {
  // console.log(action.payload);
  yield put({
    type: GET_ENTRY_LOADING,
    payload: true,
  });
  try {
    let res = yield call(getEntry, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: GET_ENTRY_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: GET_ENTRY_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVE_GET_ERROR,
    //   payload: error.toString(),
    // });
  }
}

function* updateEntry(action){
  yield put({
    type: UPDATE_ENTRY_LOADING,
    payload: true,
  });
  try {
    let res = yield call(updateTimeEntry, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: UPDATE_ENTRY_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: UPDATE_ENTRY_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* entryDelete(action) {
  // console.log(action.payload);

  try {
    let res = yield call(deleteEntry, action.payload);
    let response = res.response.data;
    // console.log(response.message);
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      // console.log(response.message);
      yield put({
        type: DELETE_ENTRY_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: DELETE_ENTRY_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVES_DELETE_ERROR,
    //   payload: error.toString(),
    // });
  }
}

function* addTimeEntry(action) {
  yield put({
    type: ADD_TIME_ENTRY_LOADING,
    payload: true,
  });
  try {
    let res = yield call(createTimeEntry, action.payload);
    let response = res.response.data;

    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: ADD_TIME_ENTRY_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: ADD_TIME_ENTRY_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* getTimeEntryByDate(action) {
  yield put({
    type: GET_TIME_ENTRY_LOADING,
    payload: true,
  });

  try {
    let res = yield call(getTimeEntry, action.payload);
    let response = res.response.data;
    
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: GET_TIME_ENTRY_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: GET_TIME_ENTRY_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* updateFlag(action){
  try {
    let res = yield call(flagUpdate, action.payload);
    let response = res.response.data;
    // console.log(response.message[0],'resss');

    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {      
      yield put({
        type: UPDATE_FLAG_SUCCESS,
        payload: response.message,
      });
    } else {      
      yield put({
        type: UPDATE_FLAG_ERROR,
        payload: response.message[0],
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* allEntriesGet(action) {
  // console.log(action.payload);
  yield put({
    type: GET_ALL_ENTRIES_LOADING,
    payload: true,
  });
  try {
    let res = yield call(getAdminEntries, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: GET_ALL_ENTRIES_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: GET_ALL_ENTRIES_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVE_GET_ERROR,
    //   payload: error.toString(),
    // });
  }
}
function* allEmployees(){
try {
    let res = yield call(supervisorTeam);
    let response = res.response.data;
    // console.log(response.message);
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      // console.log(response.message);
      yield put({
        type: SUPERVISOR_TEAM_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: SUPERVISOR_TEAM_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVES_DELETE_ERROR,
    //   payload: error.toString(),
    // });
  }
}
function* allTeamEntries(action){  
    yield put({
    type: SUPERVISOR_ALL_ENTRIES_LOADING,
    payload: true,
  });
try {
    let res = yield call(getAllTeamEntries ,action.payload);
    let response = res.response.data;
    // console.log(response.message);
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      // console.log(response.message);
      yield put({
        type: SUPERVISOR_ALL_ENTRIES_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: SUPERVISOR_ALL_ENTRIES_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVES_DELETE_ERROR,
    //   payload: error.toString(),
    // });
  }
}
export function* timeEntrySaga() {
  yield takeEvery("ACTIVE_PROJECT_ACTION", activeProjectsFetch);
  yield takeLatest("ADD_TIME_ENTRY_ACTION", addTimeEntry);
  yield takeLatest("GET_TIME_ENTRY_ACTION", getTimeEntryByDate);
  yield takeLatest("UPDATE_ENTRY_ACTION",updateEntry);
  yield takeLatest("UPDATE_FLAG_ACTION",updateFlag);
  yield takeLatest("DELETE_ENTRY_ACTION",entryDelete);
yield takeLatest("GET_ENTRY_ACTION",entryGet);
yield takeLatest("GET_ALL_ENTRIES_ACTION",allEntriesGet);
yield takeLatest("SUPERVISOR_TEAM_ACTION",allEmployees);
yield takeLatest("SUPERVISOR_ALL_ENTRIES_ACTION",allTeamEntries)
}
